import "../../Landing.css";
import "./BranchDropdown.css";
import { useEffect, useState, useRef } from "react";

function BranchDropdown(props) {
  const [open, setOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(props.text);

  let menuRef = useRef();

  useEffect(() => {
    if (props.text) {
      setSelectedBranch(props.text);
    }
  }, [props.text]);

  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const handleBranchSelect = (branch) => {
    setSelectedBranch(branch);
    setOpen(false);
  };

  return (
    <div className="App">
      <div className="menu-container" ref={menuRef}>
        <div
          className="menu-trigger"
          onClick={() => {
            setOpen(!open);
          }}
        >
          <div className="branch_name">{selectedBranch}</div>
          {/* <div className="branch_name">Branch_name</div> */}
        </div>

        {/* <div className={`branch-dropdown-menu ${open ? "active" : "inactive"}`}> */}
        <div
          className={`branch-dropdown-menu ${open ? "inactive" : "inactive"}`}
        >
          <div className="list">
            <DropdownItem text={"Saket Nagar"} onSelect={handleBranchSelect} />
            <DropdownItem text={"Kolar"} onSelect={handleBranchSelect} />
            <DropdownItem text={"MP Nagar"} onSelect={handleBranchSelect} />
          </div>
        </div>
      </div>
    </div>
  );
}

function DropdownItem(props) {
  return (
    <li
      className="branch-dropdownItem"
      onClick={() => props.onSelect(props.text)}
    >
      {/* <img src={props.img}></img> */}
      <a>{props.text}</a>
    </li>
  );
}

export default BranchDropdown;
